import { type PropsWithClassName } from "@/components/podkit/lib/cn";
import { useId, useRef, type FC } from "react";

export const RiderLogo: FC<PropsWithClassName> = ({ className }) => {
    const id = useRef(useId()).current;

    return (
        <svg
            className={className}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M23.9688 9.31447L7.18753 0.0012207L18.4233 16.6952L20.7323 15.1817L23.9688 9.31447Z"
                fill={`url(#paint0_linear_${id})`}
            />
            <path
                d="M17.2738 5.51692L15.1717 0.377808L10.5213 4.95589L12.4239 21.5676L16.9297 23.939L23.9688 19.8272L17.2738 5.51692Z"
                fill={`url(#paint1_linear_${id})`}
            />
            <path
                d="M7.18753 0.0012207L0.0311661 4.82117L2.69174 21.2609L9.55387 23.899L18.4233 16.6952L7.18753 0.0012207Z"
                fill={`url(#paint2_linear_${id})`}
            />
            <path d="M4.51948 4.51953H19.4805V19.4806H4.51948V4.51953Z" fill="black" />
            <path d="M6.38462 16.653H11.995V17.588H6.38462V16.653Z" fill="white" />
            <path
                d="M6.38961 6.36972H8.95792C9.25522 6.35142 9.55319 6.39248 9.83445 6.49052C10.1157 6.58855 10.3746 6.7416 10.5962 6.94073C10.7587 7.11195 10.8853 7.31404 10.9684 7.53504C11.0515 7.75604 11.0894 7.99147 11.0799 8.22738V8.24234C11.0985 8.62546 10.9903 9.00403 10.7722 9.31953C10.554 9.63503 10.238 9.86989 9.87304 9.9878L11.2495 11.9976H9.80073L8.59636 10.1973H7.63636V11.9976H6.38961V6.36972ZM8.88312 9.11258C9.48655 9.11258 9.83314 8.79091 9.83314 8.31715V8.30219C9.83314 7.77107 9.4641 7.49678 8.86068 7.49678H7.63636V9.11258H8.88312Z"
                fill="white"
            />
            <path
                d="M12.1072 6.36975H14.3015C16.0694 6.36975 17.2937 7.58409 17.2937 9.16746V9.18492C17.2937 10.7683 16.0719 11.9976 14.3015 11.9976H12.1072V6.36975ZM13.354 7.48684V10.878H14.3115C14.5363 10.8913 14.7614 10.857 14.9722 10.7774C15.1829 10.6978 15.3745 10.5748 15.5344 10.4162C15.6944 10.2576 15.8192 10.0671 15.9006 9.85715C15.982 9.64715 16.0183 9.42234 16.0071 9.19739V9.18243C16.0185 8.95663 15.9825 8.73094 15.9013 8.51992C15.8202 8.30889 15.6957 8.11721 15.536 7.95723C15.3762 7.79724 15.1847 7.67251 14.9738 7.59106C14.7629 7.50961 14.5373 7.47326 14.3115 7.48435L13.354 7.48684Z"
                fill="white"
            />
            <defs>
                <linearGradient
                    id={`paint0_linear_${id}`}
                    x1="22.4303"
                    y1="13.713"
                    x2="3.97839"
                    y2="3.12558"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#DD1265" />
                    <stop offset="0.48" stopColor="#DD1265" />
                    <stop offset="0.94" stopColor="#FDB60D" />
                </linearGradient>
                <linearGradient
                    id={`paint1_linear_${id}`}
                    x1="11.4589"
                    y1="2.09085"
                    x2="18.7724"
                    y2="22.2882"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.14" stopColor="#087CFA" />
                    <stop offset="0.48" stopColor="#DD1265" />
                    <stop offset="0.96" stopColor="#087CFA" />
                </linearGradient>
                <linearGradient
                    id={`paint2_linear_${id}`}
                    x1="5.98067"
                    y1="2.71416"
                    x2="11.3816"
                    y2="21.9142"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.28" stopColor="#DD1265" />
                    <stop offset="0.97" stopColor="#FDB60D" />
                </linearGradient>
            </defs>
        </svg>
    );
};
